import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ShoppingBag, Instagram } from "lucide-react";
import { LINKS, scrollToId } from "../data/site";

const NAV = [
  ["Início", "#inicio"],
  ["Produtos", "#produtos"],
  ["Sobre", "#sobre"],
  ["Contato", "#contato"],
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-white/80 shadow-[0_8px_30px_rgba(183,148,230,0.16)] backdrop-blur-xl"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 py-3 sm:px-8">
        <a href="#inicio" onClick={scrollToId("#inicio")} data-testid="nav-logo" className="flex items-center gap-3">
          <img src="images/logo-anime-glam.jpg" alt="Logo da Anime Glam" className="h-11 w-11 rounded-full border-2 border-pinky object-cover shadow-[0_4px_14px_rgba(247,168,196,0.5)]" />
          <span className="font-display text-lg font-semibold text-ink">
            Anime<span className="text-lilac"> Glam</span>
          </span>
        </a>

        <div className="hidden items-center gap-8 md:flex">
          {NAV.map(([label, id]) => (
            <a key={id} href={id} onClick={scrollToId(id)} data-testid={`nav-link-${id.slice(1)}`} className="text-sm font-bold text-ink/70 transition-colors duration-300 hover:text-lilac">
              {label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2.5">
          <a
            href={LINKS.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-instagram-link"
            aria-label="Instagram da Anime Glam"
            className="grid h-10 w-10 place-items-center rounded-full border-2 border-pink-200 bg-white/80 text-ink transition-transform duration-300 hover:scale-110 hover:text-instagram"
          >
            <Instagram size={17} />
          </a>
          <a
            href={LINKS.shopee}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-shopee-cta"
            className="flex items-center gap-2 rounded-full bg-shopee px-4 py-2.5 text-sm font-extrabold text-white shadow-[0_8px_20px_rgba(238,77,45,0.35)] transition-transform duration-300 hover:scale-105"
          >
            <ShoppingBag size={16} />
            <span className="hidden sm:inline">Loja Shopee</span>
          </a>
        </div>
      </nav>
    </motion.header>
  );
}
